import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["surveyId", "surveyType", "promptText", "positiveButtonText", "negativeButtonText", "positiveTitle", "negativeTitle", "positiveSelectableResponses", "negativeSelectableResponses", "onPromptOptionClick", "onReady"];
import { useCallback, useEffect, useRef, useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { Text } from 'foundations-components/components/Text';
import { ThumbsDownIcon } from 'foundations-assets';
import { ThumbsUpIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Spacer } from 'foundations-components/components/Spacer';
import FeedbackSurveyModalContent from './FeedbackSurveyModalContent';
import useFeedbackSurveyConfig from '../hooks/useFeedbackSurveyConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NEGATIVE_RATING = 0;
const POSITIVE_RATING = 2;
const FeedbackSurveyPrompt = _ref => {
  let {
      surveyId,
      surveyType,
      promptText,
      positiveButtonText,
      negativeButtonText,
      positiveTitle,
      negativeTitle,
      positiveSelectableResponses,
      negativeSelectableResponses,
      onPromptOptionClick,
      onReady
    } = _ref,
    modalContentProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [rating, setRating] = useState(null);
  const promptViewed = useRef(false);
  const {
    loading,
    surveyConfig,
    setSurveyConfig
  } = useFeedbackSurveyConfig({
    surveyId,
    surveyType
  });
  useEffect(() => {
    if (surveyConfig !== null && surveyConfig !== void 0 && surveyConfig.config && !promptViewed.current) {
      onReady === null || onReady === void 0 || onReady();
      promptViewed.current = true;
    }
  }, [onReady, surveyConfig === null || surveyConfig === void 0 ? void 0 : surveyConfig.config]);
  const handlePromptOptionClick = useCallback(selectedRating => {
    const promptOption = selectedRating === NEGATIVE_RATING ? 'negative' : 'positive';
    onPromptOptionClick === null || onPromptOptionClick === void 0 || onPromptOptionClick(promptOption);
    setRating(selectedRating);
  }, [onPromptOptionClick, setRating]);
  if (loading || !(surveyConfig !== null && surveyConfig !== void 0 && surveyConfig.config)) {
    return null;
  }
  if (rating !== null) {
    return /*#__PURE__*/_jsx(FeedbackSurveyModalContent, Object.assign({
      surveyId: surveyId,
      surveyConfig: surveyConfig,
      onClose: () => setSurveyConfig(null),
      title: rating === NEGATIVE_RATING ? negativeTitle : positiveTitle,
      selectableResponses: rating === NEGATIVE_RATING ? negativeSelectableResponses : positiveSelectableResponses,
      rating: rating
    }, modalContentProps));
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsx(Text, {
      color: "text-core-subtle",
      display: "inline-block",
      children: promptText
    }), /*#__PURE__*/_jsxs(ButtonGroup, {
      children: [/*#__PURE__*/_jsxs(Button, {
        size: "sm",
        use: "tertiary-extra-light",
        onClick: () => handlePromptOptionClick(POSITIVE_RATING),
        children: [positiveButtonText, /*#__PURE__*/_jsx(ThumbsUpIcon, {})]
      }), /*#__PURE__*/_jsx(Spacer, {
        display: "inline-block",
        space: "200"
      }), /*#__PURE__*/_jsxs(Button, {
        size: "sm",
        use: "tertiary-extra-light",
        onClick: () => handlePromptOptionClick(NEGATIVE_RATING),
        children: [negativeButtonText, /*#__PURE__*/_jsx(ThumbsDownIcon, {})]
      })]
    })]
  });
};
export default FeedbackSurveyPrompt;